export default function DeduplicateQS(qs) {
    if(qs.products)
        delete qs.product_ids;
    if(qs.tracks)
        delete qs.track_ids;
    
    return qs;
}
